import { useCallback } from "react";

export const useZendeskMessagingSignIn = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;
    const broadcastChannel = new BroadcastChannel(
        "zendesk-messaging-oauth2-code",
    );

    const getCookieValue = useCallback(
        (name) =>
            document.cookie
                .match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
                ?.pop() || "",
        [],
    );

    async function fetchPopupUrl() {
        const response = await fetch(
            `${backendEndpoint}/oauth2/zendesk-messaging/`,
            {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": getCookieValue("csrfToken"),
                },
            },
        );
        const { url } = await response.json();
        return url;
    }

    function openPopup(url, name, width = 500, height = 600) {
        const left = window.screenX + (window.innerWidth - width) / 2;
        const top = window.screenY + (window.innerHeight - height) / 2;

        window.open(
            url,
            name,
            `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes`,
        );
    }

    function monitorPopup() {
        return new Promise((resolve, reject) => {
            broadcastChannel.onmessage = (event) => {
                try {
                    const code = event.data;
                    resolve(code);
                } catch (error) {
                    reject(
                        new Error(`Zendesk Messaging Sign-In failed: ${error}`),
                    );
                }
            };
        });
    }

    async function completeAuthentication(code) {
        const tokenResponse = await fetch(
            `${backendEndpoint}/oauth2/zendesk-messaging/`,
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": getCookieValue("csrfToken"),
                },
                body: JSON.stringify({
                    code: code,
                }),
            },
        );

        const tokenResponseJson = await tokenResponse.json();
        return tokenResponseJson;
    }

    return { fetchPopupUrl, openPopup, monitorPopup, completeAuthentication };
};
